// ---------------------------------------------------------------------------
// Design-token vocabulary + classifiers (§4.1).
//
// CANONICAL COPY. The frontend (src/) and vercel-backend (its own src/) do not
// share a module root, and the Deno exporter shares neither, so this file is
// DUPLICATED into each runtime that needs it:
//   - vercel-backend/src/ai/content/slides/theming/tokens.ts
//   - supabase/functions/google-workspace/lib/theming/tokens.ts
// Each copy carries a `KEEP IN SYNC WITH` banner pointing here. Keep them
// identical until a shared module exists.
// ---------------------------------------------------------------------------

import type { ColorToken, FontToken } from '../types/slide';

export const COLOR_TOKENS: readonly ColorToken[] = [
  'primary',
  'primaryContrast',
  'secondary',
  'secondaryContrast',
  'background',
  'surface',
  'text',
  'textMuted',
  'accent',
];

export const FONT_TOKENS: readonly FontToken[] = ['headingFont', 'bodyFont'];

/** A token reference is `$` + a camelCase name. The name's validity for a given
 *  field type is checked separately against the token set (§4.1). */
export const TOKEN_RE = /^\$[a-z][a-zA-Z0-9]*$/;

const COLOR_TOKEN_SET: ReadonlySet<string> = new Set(COLOR_TOKENS);
const FONT_TOKEN_SET: ReadonlySet<string> = new Set(FONT_TOKENS);

/** True iff `value` is `$<name>` where `<name>` is a valid color token. */
export function isColorToken(value: string): value is `$${ColorToken}` {
  return TOKEN_RE.test(value) && COLOR_TOKEN_SET.has(value.slice(1));
}

/** True iff `value` is `$<name>` where `<name>` is a valid font token. */
export function isFontToken(value: string): value is `$${FontToken}` {
  return TOKEN_RE.test(value) && FONT_TOKEN_SET.has(value.slice(1));
}
